import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import AdvertiserRightSideImg from "../../Assests/imgs/new/AdvertiserRightSideImg.png";
import playStoreIcon from "../../Assests/imgs/new/playStoreIcon.png";
import starImg from "../../Assests/imgs/new/starImg.png";
import CarIcon from "../../Assests/imgs/new/CarIcon.png";
import CarIcon1 from "../../Assests/imgs/new/CarIcon1.png";
import CarIcon2 from "../../Assests/imgs/new/CarIcon2.png";
import CarIcon3 from "../../Assests/imgs/new/CarIcon3.png";
import Gear from "../../Assests/imgs/car_gear.png";
import Time from "../../Assests/imgs/chronic.png";
import Chronic from "../../Assests/imgs/calendar_month.png";
import AffordableCarImg from "../../Assests/imgs/new/AffordableCarImg.png";
import { addDays } from "date-fns";
import { User, Phone, Mail, Car, Calendar, Upload, X } from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AboutBenefits from "../Sections/AboutBenefits";
import Testimonials from "../Sections/Testimonials";
import { useNavigate } from "react-router-dom";
import Blog from "../Sections/Blogs";
import {
  combiled_form_data,
  empty_form,
  handleError,
} from "../../CommonJquery/CommonJquery";
import {
  save_contact,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import { Modal } from "react-bootstrap";
import Succes_tick_gif from "../../Assests/imgs/new/Succes_tick_gif.gif";
import Loader from "../Elements/Loader";
import CookieConsent from "../Elements/CookieConsent";
export default function AdversitePage() {
  const [formData, setFormData] = useState({
    fname: "",
    phone: "",
    email: "",
    vehicleType: "",
    startDate: "",
    rentalDuration: "",
    driversLicense: null,
  });

  const [phoneError, setPhoneError] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [vehicleTypeError, setVehicleTypeError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [rentalDurationError, setRentalDurationError] = useState("");

  const [endDateError, setEndDateError] = useState("");
  const [licenseError, setLicenseError] = useState("");
  const [showLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [showSucessModal, setShowSucessModal] = useState(false);
  const handleShowSucessModal = () => setShowSucessModal(true);
  const handleCloseSuccModal = () => setShowSucessModal(false);

  const successMsg =
    "Thank you for submitting your request. Our team will get back to you shortly..";
  const vehicleTypes = ["Hybrid Sedan", "Hybrid Hatchback"];
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "");
      if (updatedValue.length >= 10) setPhoneError("");
    }

    if (name === "email") {
      updatedValue = value.toLowerCase();
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(updatedValue)) {
        setEmailError("");
      }
    }

    if (name === "fname" && updatedValue.trim() !== "") {
      setNameError("");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  const handleVehicleSelect = (vehicle) => {
    if (vehicle) setVehicleTypeError("");
    setFormData((prev) => ({
      ...prev,
      vehicleType: vehicle,
    }));
  };

  const handleDateChange = (date, name) => {
    if (name === "startDate") {
      if (date) setStartDateError("");
      if (formData.endDate && formData.endDate < date) {
        setEndDateError("End date cannot be before start date.");
      } else {
        setEndDateError("");
      }
    }

    if (name === "endDate") {
      if (date) {
        if (formData.startDate && date < formData.startDate) {
          setEndDateError("End date cannot be before start date.");
        } else {
          setEndDateError("");
        }
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: date,
    }));
  };

  const handleValidation = () => {
    let isValid = true;

    // Reset all errors
    setNameError("");
    setPhoneError("");
    setEmailError("");
    setVehicleTypeError("");
    setStartDateError("");
    setRentalDurationError("");
    setLicenseError("");

    // Name
    if (!formData.fname.trim()) {
      setNameError("Name is required.");
      isValid = false;
    }

    // Phone
    if (!formData.phone.trim()) {
      setPhoneError("Phone number is required.");
      isValid = false;
    } else if (formData.phone.length < 10) {
      setPhoneError("Enter a valid 10-digit phone number.");
      isValid = false;
    }

    // Email
    if (!formData.email.trim()) {
      setEmailError("Email is required.");
      isValid = false;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      setEmailError("Enter a valid email address.");
      isValid = false;
    }

    // Vehicle Type
    if (!formData.vehicleType) {
      setVehicleTypeError("Vehicle type is required.");
      isValid = false;
    }

    // Start Date
    if (!formData.startDate) {
      setStartDateError("Start date is required.");
      isValid = false;
    }

    // Rental Duration (new validation)
    if (!formData.rentalDuration) {
      setRentalDurationError("Rental duration is required.");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async (form_data) => {
    if (handleValidation()) {
      setShowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("from_where", "1");
      fd_from.append("source", "Paid");
      await server_post_data(save_contact, fd_from)
        .then((Response) => {
          if (Response.error) {
            console.log(Response.error);
          } else {
            empty_form(form_data);
            setFormData({
              fname: "",
              phone: "",
              email: "",
              vehicleType: "",
              startDate: "",
              rentalDuration: "",
              driversLicense: null,
            });
            navigate("/Thank-you");
            setShowLoaderAdmin(false);
          }
        })
        .catch((error) => {
          setShowLoaderAdmin(false);
        });
    }
  };
  useEffect(() => {
    if (showSucessModal) {
      const timer = setTimeout(() => {
        handleCloseSuccModal();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [handleCloseSuccModal]);

  //---------Cookie Consent-----------------
  const handleCookieAccept = (preferences) => {
    console.log("Cookies accepted:", preferences);
  };

  const handleCookieDecline = (preferences) => {
    console.log("Cookies declined:", preferences);
  };

  const handleCookieCustomize = (preferences) => {
    console.log("Cookie preferences customized:", preferences);
  };
  return (
    <>
      {showLoaderAdmin && (
        <div className="loder_clsss_Login">
          <Loader />
        </div>
      )}
      <Layout>
        <section className="container-lg sectionHeightNew">
          <div className="row h-100 mx-auto m-0 justify-content-between align_center_clss padding_left_right">
            <div className="col-md-12 col-lg-8 col-xl-7 p-0 d-flex align-items-center">
              <div className="left_side_hero">
                <h1 className="adversiteheroHead">
                  Car Rentals for Drivers & GIG Workers
                </h1>
                <form id="contact_form">
                  <div className="row margin_clss">
                    {/* Name */}
                    <div className="col-md-6">
                      <div className="input_form_group">
                        <div className="input-wrapper">
                          <User className="input-icon" size={20} />
                          <input
                            type="text"
                            name="fname"
                            value={formData.fname}
                            onChange={handleInputChange}
                            placeholder="Name"
                            className="form-input"
                          />
                        </div>
                        {nameError && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {nameError}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="col-md-6">
                      <div className="input_form_group">
                        <div className="input-wrapper">
                          <Phone className="input-icon" size={20} />
                          <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            placeholder="Phone No."
                            className="form-input form-control"
                          />
                        </div>
                        {phoneError && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {phoneError}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-md-6">
                      <div className="input_form_group">
                        <div className="input-wrapper">
                          <Mail className="input-icon" size={20} />
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Email Address"
                            className="form-input form-control"
                          />
                        </div>
                        {emailError && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {emailError}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Vehicle Type */}
                    <div className="col-md-6">
                      <div className="input_form_group">
                        <div className="input-wrapper selcter_container">
                          <Car className="input-icon" size={20} />
                          <select
                            value={formData.vehicleType}
                            name="vehicleType"
                            onChange={(e) =>
                              handleVehicleSelect(e.target.value)
                            }
                            className="form-select form-control"
                          >
                            <option value="" disabled hidden>
                              Select Vehicle Type
                            </option>
                            {vehicleTypes.map((type, index) => (
                              <option key={index} value={type}>
                                {type}
                              </option>
                            ))}
                          </select>
                        </div>
                        {vehicleTypeError && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {vehicleTypeError}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Dates */}
                    <div className="col-lg-6">
                      <div className="input_form_group">
                        <div
                          className="date-container"
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className="date-input-wrapper"
                            style={{ width: "50%" }}
                            onClick={() =>
                              document.getElementById("start-picker").focus()
                            }
                          >
                            <Calendar className="input-icon" size={20} />
                            <DatePicker
                              id="start-picker"
                              name="from_date"
                              selected={formData.startDate}
                              onChange={(date) =>
                                handleDateChange(date, "startDate")
                              }
                              className="date-input form-control"
                              placeholderText="Start Date"
                              dateFormat="yyyy-MM-dd"
                              shouldCloseOnSelect={true}
                              onCalendarClose={() =>
                                document.activeElement.blur()
                              }
                              minDate={addDays(new Date(), 1)}
                            />
                          </div>
                          <div className="date-divider">|</div>
                          <select
                            value={formData.rentalDuration}
                            name="duration_type"
                            onChange={(e) => {
                              setRentalDurationError("");
                              setFormData((prev) => ({
                                ...prev,
                                rentalDuration: e.target.value,
                              }));
                            }}
                            className="form-select ren_duration_selctr form-control"
                          >
                            <option value="" disabled hidden>
                              Select Duration
                            </option>
                            <option value="Few days">Few days</option>
                            <option value="Few weeks">Few weeks</option>
                            <option value="Few months">Few months</option>
                          </select>
                        </div>
                        {startDateError && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {startDateError}
                          </span>
                        )}
                        {rentalDurationError && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {rentalDurationError}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Driver's License */}
                    <div className="col-lg-6">
                      <div className="input_form_group">
                        <div className="custom_file_upload_input">
                          <div
                            className="inner_file_upload"
                            onClick={() => {
                              if (!formData.driversLicense) {
                                document
                                  .getElementById("driver-license-input")
                                  .click();
                              }
                            }}
                            style={{
                              cursor: formData.driversLicense
                                ? "default"
                                : "pointer",
                            }}
                          >
                            <div className="upload_label">
                              <Upload
                                size={20}
                                style={{ marginRight: "17px" }}
                              />
                              <span className="mx-0">
                                {formData.driversLicense
                                  ? `${formData.driversLicense.name.slice(
                                      0,
                                      40
                                    )}...`
                                  : "Upload Driver's License"}
                              </span>
                            </div>

                            {!formData.driversLicense ? (
                              <label className="choose_file_btn">
                                Choose File
                                <input
                                  type="file"
                                  id="driver-license-input"
                                  name="driving_licence_image"
                                  hidden
                                  onChange={(e) => {
                                    if (e.target.files[0]) {
                                      setLicenseError("");
                                      setFormData((prev) => ({
                                        ...prev,
                                        driversLicense: e.target.files[0],
                                      }));
                                    }
                                  }}
                                />
                              </label>
                            ) : (
                              <button
                                type="button"
                                className="choose_file_btn_cross_icn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setFormData((prev) => ({
                                    ...prev,
                                    driversLicense: null,
                                  }));
                                }}
                              >
                                <X className="removeDL" size={18} />
                              </button>
                            )}
                          </div>
                        </div>

                        {licenseError && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {licenseError}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="col-12">
                      <div className="d-flex">
                        <button
                          type="button"
                          className="submt_add_Btttn"
                          onClick={() => handleSubmit("contact_form")}
                        >
                          <h6> Submit Enquiry</h6>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="play_store_icon_div">
                  <a href="https://play.google.com/store/apps/details?id=com.rapidcarleasing&pcampaignid=web_share">
                    <img
                      src={playStoreIcon}
                      className="playStoreIcon"
                      alt="Play Store"
                    />
                  </a>
                  <div className="rating_star_img">
                    <img
                      src={starImg}
                      className="playStoreIcon"
                      alt="Rating Stars"
                    />
                    <p>4.6/5 from 100k ratings in app stores</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5 h-100 col-lg-4 col-xl-4 d-lg-flex d-none p-0 display_none_mobile">
              <div className="right_side_img_advertise">
                <img src={AdvertiserRightSideImg} alt="Car Rental" />
              </div>
            </div>
          </div>
        </section>

        {/**------------section 2------------- */}
        <div className="section2Advertise">
          <div className="container-lg padding_left_right">
            <div className="cariconsImgContainer">
              <div className="imgSec1">
                <img src={CarIcon} alt="image" title="img"></img>
                <p>8+ Years in Business</p>
              </div>
              <div className="imgSec1">
                <img src={CarIcon1} alt="image" title="img"></img>
                <p>2000 + Rentals</p>
              </div>
              <div className="imgSec1">
                <img src={CarIcon2} alt="image" title="img"></img>
                <p>100 + Cars in Fleet</p>
              </div>
              <div className="imgSec1">
                <img src={CarIcon3} alt="image" title="img"></img>
                <p>Transparent Pricing</p>
              </div>
            </div>
            {/**------------section 4------------- */}
            <div className="afortable_car_contaner">
              <div class="affordable-car-container">
                <div class="car-image">
                  <img src={AffordableCarImg} alt="Driver with phone" />
                </div>
                <div class="car-content">
                  <h2>Affordable & Easy Car Rentals for Drivers</h2>
                  <p>
                    Choose from a wide range of rideshare car rentals - Rent a
                    car for Lyft, Uber or Doordash and more.
                  </p>
                  <ul>
                    <li>
                      <img
                        src={Gear}
                        alt=" Built for Drivers – Drive on Platforms like Uber, Lyft and
                      more"
                        title=" Built for Drivers – Drive on Platforms like Uber, Lyft and
                      more"
                      />
                      <span>
                        <h6>Built for Drivers</h6>
                        <p>
                          Facilitating rental car for Uber drivers & car rental
                          for lyft and Doordash
                        </p>
                      </span>
                    </li>
                    <li>
                      <img
                        src={Time}
                        alt="Flexible Long-Term Car Rental – Rent for a Few Days or a Few
                    Weeks"
                        title="Flexible Long-Term Car Rental – Rent for a Few Days or a Few
                    Weeks"
                      />
                      <span>
                        <h6>Flexible Long-Term Car Rental</h6>
                        <p>
                          Rent for a few Days or a Few Weeks. Rideshare Chicago
                          made easy with RCL
                        </p>
                      </span>
                    </li>
                    <li>
                      <img
                        src={Chronic}
                        alt=" Streamlined Online Reservations – Fast, Simple & Secure"
                        title=" Streamlined Online Reservations – Fast, Simple & Secure"
                      />
                      <span>
                        <h6>Streamlined Online Reservations</h6>
                        <p>
                          Complete Your Vehicle Booking 100% Online — Fast,
                          Simple & Secure.
                        </p>
                      </span>
                    </li>
                  </ul>
                  <button class="cta-btn" onClick={() => navigate("/")}>
                    See how it works ➜
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/**------------section 3------------- */}
          <AboutBenefits />
          {/**------------section 4------------- */}
          <div style={{ paddingTop: "5rem", backgroundColor: "white" }}></div>
          <Testimonials />
          {/**------------section 5------------- */}
          <Blog />
        </div>

        {/* <ToastContainer /> */}
        <CookieConsent
          position="bottom"
          buttonText="Accept All"
          customizeButtonText="Customize"
          declineButtonText="Decline All"
          cookieName="car-site-cookie-consent"
          expires={365}
          onAccept={handleCookieAccept}
          onDecline={handleCookieDecline}
          onCustomize={handleCookieCustomize}
        />
      </Layout>
    </>
  );
}
